import { render, staticRenderFns } from "./RippedHeader.vue?vue&type=template&id=22c39e66"
import script from "./RippedHeader.vue?vue&type=script&lang=js"
export * from "./RippedHeader.vue?vue&type=script&lang=js"
import style0 from "./RippedHeader.vue?vue&type=style&index=0&id=22c39e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports